var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
function SvgClose(props) {
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "11", height: "11", fill: "#FFFFFF" }, props, { children: _jsx("path", { d: "M10.713 9.253c.192.21.287.458.287.744a.971.971 0 01-.287.716.971.971 0 01-.716.287 1.07 1.07 0 01-.744-.287L5.5 6.962l-3.753 3.752a1.035 1.035 0 01-1.432 0A.927.927 0 010 9.998c0-.286.105-.534.315-.744L4.04 5.5.315 1.747A1.018 1.018 0 010 1.003C0 .716.105.477.315.286a1.036 1.036 0 011.432 0L5.5 4.04 9.253.286A1.07 1.07 0 019.997 0c.287 0 .526.095.716.286.192.191.287.43.287.717 0 .286-.095.534-.287.744L6.962 5.5l3.752 3.753z" }) })));
}
export default SvgClose;
